import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { TypeUtils } from '@vectord/utils';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import styles from './SortableTableCellOption.module.scss';

function SortableTableCellOption({
  field,
  value,
  children,
  isDisabled,
  isSelected,
  handleSelect,
  handleReset,
}) {
  const handleSortChange = useCallback(() => {
    if (TypeUtils.isFunction(handleSelect)) {
      handleSelect(field, value);
    }
    if (TypeUtils.isFunction(handleReset)) {
      handleReset();
    }
  }, [field, handleReset, handleSelect, value]);

  return (
    <Tappable
      onClick={handleSortChange}
      className={classNames(styles.root, {
        [styles.selected]: isSelected,
      })}
      disabled={isDisabled}
    >
      {children}
    </Tappable>
  );
}

SortableTableCellOption.propTypes = {
  children: PropTypes.node,
  field: PropTypes.string,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleSelect: PropTypes.func,
  handleReset: PropTypes.func,
};

export default SortableTableCellOption;
